export default __webpack_public_path__ + "static/bell-7083e374116ea84d846ea0fd4ffb828b.png";